import { makeStyles } from '@material-ui/core/styles'
export default makeStyles({
    selected: {
        color: '#b779ff',
        backgroundColor: 'black',
    },
})
